import { render, staticRenderFns } from "./AppTutooria.vue?vue&type=template&id=25e4a9c6&"
import script from "./AppTutooria.vue?vue&type=script&lang=js&"
export * from "./AppTutooria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports